document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll('.brands .item');
  const label = document.querySelector('.brands__label p');

  items.forEach((item) => {
    item.addEventListener('mouseover', () => {
      document.querySelector('.brands .active').classList.remove('active')
      item.classList.add('active')
      label.innerHTML = item.dataset.label
    })
  })
});